import { render, staticRenderFns } from "./TeacherResourceDetails.vue?vue&type=template&id=1b968e19&scoped=true&"
import script from "./TeacherResourceDetails.vue?vue&type=script&lang=js&"
export * from "./TeacherResourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeacherResourceDetails.vue?vue&type=style&index=0&id=1b968e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b968e19",
  null
  
)

export default component.exports